<div class="d-flex flex-column flex-fill p-2 hide-scroll-bar"
     style="min-height: calc(100vh - 150px); max-height: calc(100vh - 150px); border: 1px solid #ced4da; border-radius: 6px;">
    <div class="d-flex">
        <div class="d-flex col-6">
            <div>
                <slick-search-bar (onSearch)="onSearch($event)" [showAddButton]="false" [showEditButton]="false"></slick-search-bar>
            </div>
            <div *ngIf="!hideNewButton" class="ms-2">
                <button type="button"
                        class="btn btn-outline-primary"
                        style="width: 80px; border-radius: 19px;"
                        (click)="onNewInvoice()">
                    <i class="far fa-plus"></i>
                    <span class="d-none d-xl-inline-block">&nbsp;New</span>
                </button>
            </div>

        </div>

        <div class="d-flex col-6" style="justify-content:flex-end">
            <div class="ms-2 me-1 p-0">

                <slick-drop-down placeholder="Batch Actions" [items]="batchItems" [(ngModel)]="batchActionId"></slick-drop-down>
                <form-error *ngIf="isSubmitted && !batchActionId">Batch action required</form-error>
            </div>

            <button [disabled]="!batchActionId || gridModelsForBatch.length === 0" type="button" class="btn btn-sm btn-outline-primary" style="min-width:55px; max-width: 55px; height: 2.5rem;" (click)="performBatch()">Go</button>
            <button class="btn btn-outline-success ms-1" (click)="exportToCSV()"> Export</button>
        </div>
    </div>

    <div [class.d-none]="hideFilters">
        <div class="mt-1">
            <locations-selector key="INVOICES" (onLocationsChanged)="onLocationsChanged($event)"></locations-selector>
        </div>

        <div class="mt-2 mb-2" style="display: flex; flex-wrap: wrap; column-gap: 15px; row-gap: 8px;">
            <div>
                <div>Invoice Status</div>
                <div style="width:220px">
                    <slick-drop-down [ngModel]="selectedInvoiceStatus"
                                     [items]="invoiceStatuses"
                                     allowEmpty="false"
                                     (onChange)="onInvoiceStatusChanged($event)"></slick-drop-down>
                </div>
            </div>
            <div>
                <div>Show invoices from</div>
                <div style="width:220px">
                    <slick-drop-down [ngModel]="selectedInvoiceMonths"
                                     [items]="invoiceMonths"
                                     allowEmpty="false"
                                     (onChange)="onInvoiceMonthsChanged($event)">
                    </slick-drop-down>
                </div>
            </div>
            <div>
                <div>Sales Rep</div>
                <div style="width:220px">
                    <slick-drop-down [ngModel]="selectedSalesRepUserId"
                                     [items]="salesReps"
                                     allowEmpty="true"
                                     (onChange)="onSalesRepChanged($event)">
                    </slick-drop-down>
                </div>
            </div>
            <div>
                <div>AR Rep</div>
                <div style="width:220px">
                    <slick-drop-down [ngModel]="selectedArRepId"
                                     [items]="arReps"
                                     allowEmpty="true"
                                     (onChange)="onArRepChanged($event)">
                    </slick-drop-down>
                </div>
            </div>
        </div>

        <div class="pt-1" style="font-size: .8rem; line-height: 1rem;">
            <span *ngIf="isJellyfish"><input type="checkbox" [ngModel]="showDealersOnly" (change)="onShowDealersOnlyChanged()" />Dealers Only&nbsp;&nbsp;</span>
            <span *ngIf="isJellyfish"><input type="checkbox" [ngModel]="showInternalSales" (change)="onShowInternalSalesChanged()" />Show DSM Sales&nbsp;&nbsp;</span>

            <span *ngIf="isQuickbooksEnabled">
                <input type="checkbox" [ngModel]="showNotSyncedToQuickbooks" (click)="onShowNotSyncedToQuickbooksClicked()" />Show Not Synced&nbsp;&nbsp;
            </span>
            <span *ngIf="isBusinessCentralEnabled">
                <input type="checkbox" [ngModel]="showNotSyncedToBusinessCentral" (click)="onShowNotSyncedToBusinessCentralClicked()" />Show Not Synced&nbsp;&nbsp;
            </span>
            <input type="checkbox" [ngModel]="showPOSOnly" (click)="onShowPOSOnlyClicked()" />Show POS Only&nbsp;&nbsp;
            <input type="checkbox" [ngModel]="showInvoicesWhereJobIsComplete" (click)="onShowInvoicesWhereJobIsCompleteClicked()" />Show Completed Jobs&nbsp;&nbsp;
            <span *ngIf="useLathamOrdering"><input type="checkbox" [ngModel]="showInvoicesWhereOrderHasShipped" (click)="onShowInvoicesWhereOrderHasShippedClicked()" />Show Shipped Orders</span>
        </div>
    </div>

    <slick-grid class="mt-3" [gridOptions]="gridOptions"
                (onRowSelected)="onRowClicked($event)"
                (onRowContextMenu)="onRowContextMenu($event)"
                #invoicesGrid>
        <ng-template let-invoiceGridModel
                     slickGridColumnTemplate="QUICKBOOKS_SYNC">
            <quickbooks-icon [quickbooksSyncStatus]="invoiceGridModel.quickbooksSyncStatus"
                             mini="true"
                             lockSynced="true"
                             (onClick)="syncToQuickbooks(invoiceGridModel)"></quickbooks-icon>
        </ng-template>
        <ng-template let-invoiceGridModel
                     slickGridColumnTemplate="BUSINESS_CENTRAL_SYNC">
            <business-central-icon [businessCentralSyncStatus]="invoiceGridModel.businessCentralSyncStatus"
                                   mini="true"
                                   lockSynced="true"
                                   (onClick)="syncToBusinessCentral(invoiceGridModel)"></business-central-icon>
        </ng-template>
        <ng-template let-invoiceGridModel slickGridColumnTemplate="BATCH_CHECKBOX"><input type="checkbox" [(ngModel)]="invoiceGridModel.batch" (click)="onBatchClicked(invoiceGridModel, $event)" /></ng-template>

        <ng-template let-invoiceGridModel slickGridColumnTemplate="ACCEPTED_DATE">
            {{invoiceGridModel.acceptedDate | date:'M/d/yyyy'}}
        </ng-template>
        <ng-template let-invoiceGridModel slickGridColumnTemplate="INVOICE_DATE">
            {{invoiceGridModel.invoiceDate | date:'M/d/yyyy'}}
        </ng-template>
        <ng-template let-invoiceGridModel slickGridColumnTemplate="INVOICE_DUE_DATE">
            {{invoiceGridModel.invoiceDueDate | date:'M/d/yyyy'}}
        </ng-template>
        <ng-template let-estimatesGridModel slickGridColumnTemplate="SALES_REP">
            {{estimatesGridModel.salesRepFullName}}
        </ng-template>
    </slick-grid>
</div>

<slick-context-menu #invoicesGridContextMenuRef>
    <slick-context-menu-item (click)="contextMenuDeleteInvoice()"><i class="bi bi-trash"></i>&nbsp;Delete Invoice</slick-context-menu-item>
</slick-context-menu>

<slick-confirm-dialog #deleteInvoiceConfirmRef>
    Are you sure you want to delete this invoice?
</slick-confirm-dialog>

<emailer-dialog #emailerDialogRef></emailer-dialog>
<batch-payment-dialog #batchPaymentDialogRef></batch-payment-dialog>

<slick-confirm-dialog #invoiceStatusSelector header="Update Invoice Status" width="400">
    <h4>
        Choose a new status to apply to the selected invoices.
    </h4>

    <div class="align-content-center" style="display: flex; justify-content: center;">

        <slick-drop-down [items]="batchInvoiceStatuses"
                         (onSelect)="onBatchInvoiceStatusSelect($event)"></slick-drop-down>
    </div>

</slick-confirm-dialog>
